import React, { useState, useEffect } from "react";
import ModalBasic from "./ModalBasic.jsx";
import { FaCrown } from "react-icons/fa6";

function RoleSelectionModal({
  modalOpen,
  setModalOpen,
  location,
  onRoleSelect,
}) {
  const [selectedIndex, setSelectedIndex] = useState(0);
  
  const roles = [
    { id: "saucey_admin", name: "Saucey Admin", icon: <FaCrown /> },
    { id: "store_admin", name: "Store Admin", icon: null },
    { id: "store_manager", name: "Store Manager", icon: null },
    { id: "store_clerk", name: "Store Clerk", icon: null },
  ];

  const handleRoleSelect = (role) => {
    if (location) {
      onRoleSelect(location, role);
      setModalOpen(false);
    }
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!modalOpen) return;

      if (e.key === "ArrowDown") {
        e.preventDefault();
        setSelectedIndex((prev) =>
          prev < roles.length - 1 ? prev + 1 : 0
        );
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setSelectedIndex((prev) =>
          prev > 0 ? prev - 1 : roles.length - 1
        );
      } else if (e.key === "Enter") {
        e.preventDefault();
        if (roles[selectedIndex]) {
          handleRoleSelect(roles[selectedIndex]);
        }
      } else if (e.key === "Escape") {
        setModalOpen(false);
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [modalOpen, selectedIndex, roles]);

  // Reset selected index when modal opens
  useEffect(() => {
    if (modalOpen) {
      setSelectedIndex(0);
    }
  }, [modalOpen]);

  return (
    <ModalBasic
      title="Select a role to impersonate this store as"
      modalOpen={modalOpen && location}
      setModalOpen={handleClose}
      width="md"
    >
      {location && (
        <div className="space-y-4">
          {/* Store Info */}
          <div className="p-4 bg-slate-50 dark:bg-slate-800 rounded-lg">
            <div className="font-medium text-slate-900 dark:text-slate-100">
              {location.name}
            </div>
            <div className="text-sm text-slate-500 dark:text-slate-400">
              {location.merchantName} • {location.store_id}
            </div>
          </div>

          {/* Role Selection */}
          <div className="space-y-2">
            {roles.map((role, index) => (
              <button
                key={role.id}
                onClick={() => handleRoleSelect(role)}
                className={`w-full p-3 text-left border rounded-lg transition-colors ${
                  index === selectedIndex
                    ? "bg-blue-50 dark:bg-blue-900/20 border-blue-300 dark:border-blue-600"
                    : "border-slate-200 dark:border-slate-600 hover:bg-slate-50 dark:hover:bg-slate-700/50"
                }`}
              >
                <div className="flex items-center">
                  {role.icon && (
                    <span className="mr-3 text-amber-500">{role.icon}</span>
                  )}
                  <span className="font-medium text-slate-900 dark:text-slate-100">
                    {role.name}
                  </span>
                </div>
              </button>
            ))}
          </div>

          {/* Instructions */}
          <div className="text-xs text-slate-500 dark:text-slate-400">
            Use ↑↓ arrows to navigate, Enter to select, or click to choose a role
          </div>
        </div>
      )}
    </ModalBasic>
  );
}

export default RoleSelectionModal;
